import { io } from 'socket.io-client';
import { verifyEnvUrl } from 'util/verifyEnvUrl';

const prdURL = 'https://bailey-api-263680973121.southamerica-east1.run.app';
const devURL = 'https://bailey-api-dev-263680973121.southamerica-east1.run.app';

// const devURL = 'https://bailey-api-263680973121.southamerica-east1.run.app';
// const devURL = 'https://bailey-api-testes-263680973121.southamerica-east1.run.app';
// const devURL = 'http://localhost:3001';

// const SOCKET_URL = 'http://localhost:3001';
const SOCKET_URL = verifyEnvUrl( prdURL,devURL );

let socket = null;

export const socketEvents = {
	connect: () => {
		if ( !socket ) {

			const token = localStorage.getItem( 'af-token' );

			socket = io( SOCKET_URL, {
				extraHeaders: {
				  Authorization: `Bearer ${token}`
				} } );
		}
		return socket;
	},

	onQRCode: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'qrcode.updated', callback );
		return () => socket.off( 'qrcode.updated', callback );
	},

	onAuthenticated: ( callback ) => {
		const socket = socketEvents.connect();
		const handler = ( event ) => {
			const eventData = event?.data?.data;
			callback( eventData?.status, eventData?.subSessionId, eventData?.isNewLogin );
		};
		socket.on( 'connection.update', handler );
		return () => socket.off( 'connection.update', handler );
	},

	onChatUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'chats.update', ( chat ) => {
			console.log( 'onChatUpdate: ', chat );
			callback( chat );
		} );
		return () => socket.off( 'chats.update', callback );
	},

	onChatsReload: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'chats.reload', ( chat ) => {
			console.log( 'onChatsReload: ', chat );
			callback( chat );
		} );
		return () => socket.off( 'chats.reload', callback );
	},

	onUnreadUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'messages.upsert', ( message ) => {
			console.log( 'onUnreadUpdate: ', message );
			callback( message );
		} );
		return () => socket.off( 'messages.upsert', callback );
	},

	onMessage: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'messages.upsert', ( message ) => {
			console.log( 'onMessage: ', message );
			callback( message );
		} );
		return () => socket.off( 'messages.upsert', callback );
	},
	onMessageSend: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'message.send', ( message ) => {
			console.log( 'onMessageSend: ', message );
			callback( message );
		} );
		return () => socket.off( 'message.send', callback );
	},
	onMessageUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'messages.update', ( message ) => {
			console.log( 'onMessageUpdate: ', message );
			callback( message );
		} );
		return () => socket.off( 'messages.update', callback );
	},
	onMessageReceived: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'message.receive', ( message ) => {
			console.log( 'onMessageReceived: ', message );
			callback( message );
		} );
		return () => socket.off( 'message.receive', callback );
	},
	onMessageUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'messages.update', ( message ) => {
			console.log( 'onMessageUpdate: ', message );
			callback( message );
		} );
		return () => socket.off( 'messages.update', callback );
	},
	onMessageStatus: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'messages.upsert', ( message ) => {
			console.log( 'onMessageStatus: ', message );
			callback( message );
		} );
		return () => socket.off( 'messages.upsert', callback );
	},

	onAuthFailure: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'connection.update', callback );
		return () => socket.off( 'connection.update', callback );
	},

	onSentMessage: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'sent-messages.upsert', callback );
		return () => socket.off( 'sent-messages.upsert', callback );
	},
	onMessagingHistorySet: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'messaging-history.set', callback );
		return () => socket.off( 'messaging-history.set', callback );
	},

	offMessagingHistorySet: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'messaging-history.set', callback );
	},
	onSubSessionUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'sub-session.updated', callback );
		return () => socket.off( 'sub-session.updated', callback );
	},
	offSubSessionUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'sub-session.updated', callback );
	},

	offMessageUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'messages.update', callback );
	},


	disconnect: () => {
		if ( socket ) {
			socket.disconnect();
			socket = null;
		}
	},
	offMessage: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'message', callback );
	},

	offChatUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'chats.update', callback );
	},

	offChatsReload: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'chats.reload', callback );
	},

	offMessageStatus: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'message-status', callback );
	},

	offUnreadUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'unread_update', callback );
	},

	offReceiveMessage: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'message.receive', callback );
	},

	offMessageSend: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'message.send', callback );
	},
	offMessageUpdate: ( callback ) => {
		const socket = socketEvents.connect();
		socket.off( 'messages.update', callback );
	},

	onConnectionStatus: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'connection_status', callback );
		return () => socket.off( 'connection_status', callback );
	},

	onDisconnected: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'disconnected', callback );
		return () => socket.off( 'disconnected', callback );
	},

	onReady: ( callback ) => {
		const socket = socketEvents.connect();
		socket.on( 'ready', callback );
		return () => socket.off( 'ready', callback );
	},
};
